import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import "firebase/firestore";
import "firebase/remote-config";
import { insertNotificationTokenInTokensListUserMetaData } from "./firestoreQueries";
import { getUserEmail } from "./utils/utils";

const firebaseConfig = {
  apiKey: "AIzaSyDA6HtEflbwwTqegy-RgyxO5Tan04LTa1A",
  authDomain: "fantasy-app-41485.firebaseapp.com",
  projectId: "fantasy-app-41485",
  storageBucket: "fantasy-app-41485.appspot.com",
  messagingSenderId: "665587058756",
  appId: "1:665587058756:web:997d7d2d0c9191dd221411",
  measurementId: "G-Q3PSD7EX32",
};

firebase.initializeApp(firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

let messaging;

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
}

const { REACT_APP_VAPID_KEY } = process.env;
const publicKey = REACT_APP_VAPID_KEY;

export const askForPermissionToReceiveNotifications = async () => {
  console.log("Requesting permission...")
  try {
    const permission = await Notification.requestPermission();
    // If the user denied the permission request or dismissed the permission request
    // then you should explain why your app needs this permission and ask them to enable it from the app settings
    if (permission !== 'granted') {
      throw new Error('Permission not granted for Notification');
    }
    const token = await messaging.getToken({ vapidKey: publicKey });
    console.log("Current token askForPermissionToReceiveNotifications: " + token);
    const email = await getUserEmail()
    await insertNotificationTokenInTokensListUserMetaData(email, token)
  } catch (error) {
    console.error(error);
  }
};

export const getToken = async (setTokenFound) => {
  let currentToken = "";

  try {
    currentToken = await messaging.getToken({ vapidKey: publicKey });
    if (currentToken) {
      console.log("Current token getToken: " + currentToken);
      const email = await getUserEmail()
      await insertNotificationTokenInTokensListUserMetaData(email, currentToken)
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
  } catch (error) {
    console.log("An error occurred while retrieving token. ", error);
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const signUpGoogle = async () => { };

export const db = firebase.firestore();

export const getID = () => {
  const user = auth.currentUser;
  if (user) {
    return user.uid;
  } else {
    // handle the case when there is no logged in user
    return null;
  }
};

export const waitForAuthInit = (auth) => {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe(); // Stop listening after the first state
      resolve(user);
    });
  });
}


export const serverTimestamp = () =>
  firebase.firestore.FieldValue.serverTimestamp();

// Remote Config Setup

const remoteConfig = firebase.remoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 1000;

let rcDefaults = require("./assets/remote_config_defaults.json");
remoteConfig.defaultConfig = rcDefaults;

export { remoteConfig };
